import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import PropTypes from 'prop-types';

import styles from './video.css';

const { div, iframe } = hh(h);

const Video = ({ src }) => (
    div({className: styles.componentContainer}, [
        div({className: styles.videoContainer}, [
            iframe({className: styles.video, src, allowFullScreen: true, frameBorder: 0})
        ])
    ])
);

Video.propTypes = {
    src: PropTypes.string.isRequired
};

export default Video;



/** WEBPACK FOOTER **
 ** ./src/Video/index.js
 **/